export default {
    XML_PATH_ORIGIN_COUNTRY_ID: 'shipping/origin/country_id',
    XML_PATH_ORIGIN_REGION_ID: 'shipping/origin/region_id',
    XML_PATH_ORIGIN_CITY: 'shipping/origin/city',
    XML_PATH_ORIGIN_POSTCODE: 'shipping/origin/postcode'
}


// WEBPACK FOOTER //
// ./src/view/constant/shipping/ConfigConstant.js